module.exports = "<mat-card fxLayout=\"column\" layout-padding>\r\n\r\n    <ng-content></ng-content>\r\n\r\n    <p style=\"font-style: italic;\" *ngIf=\"(message$ | async) as message\">\r\n        {{ message }}\r\n    </p>\r\n\r\n</mat-card>\r\n<mat-progress-bar *ngIf=\"isLoading$ | async\" mode=\"indeterminate\"></mat-progress-bar>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/password/password-operations.component.html
// module id = 1470
// module chunks = 1